const generateRoute = (
  unsafeRoute: string,
  params: Record<string, string | null> = {},
) => {
  let route = unsafeRoute;
  Object.keys(params).forEach((key) => {
    if (!params[key]) route = route.replace(`/:${key}`, '');
    else route = route.replace(`:${key}`, params[key] as string);
  });

  return route;
};
const routeNames = {
  root: (params?: Record<string, string>): string => generateRoute('/', params),
  editLocation: (params?: Record<string, string>): string =>
    generateRoute('/locations/:id', params),
  noPermission: (params?: Record<string, string>): string =>
    generateRoute('/no-permission-page', params),
  example: (params?: Record<string, string>): string =>
    generateRoute('/example', params),
  pageNotFound: (params?: Record<string, string>): string =>
    generateRoute('*', params),
};

export default routeNames;
